export const blockIconsEditorTitle = (
	<span className='material-symbols-outlined'>title</span>
);
